import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapLeftMenu = React.lazy(function () {
    return import('../../bootstrap-components/components/BTLeftMenu');
});
var bootStrapLeftMenu = function (props) {
    console.log('======Hi i am left menu displaying menuList======', props);
    return (React.createElement(BootStrapLeftMenu, __assign({}, props)));
};
var LeftMenu = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapLeftMenu(props);
            break;
        default:
            componentToDisplay = bootStrapLeftMenu(props);
            break;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
LeftMenu.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default React.memo(LeftMenu);
//# sourceMappingURL=LeftMenu.js.map